import React from 'react';
import { cn } from '../../../utils';


const Skeleton = ({ className }) => (
  <div className={cn('animate-pulse bg-gray-300', className)}></div>
);

const RonTipsCardSkeleton = ({ isInfoWindowView }) => {
  return (
    <div className='relative flex w-full flex-col justify-between sm:w-[320px]'>
      <div
        className={cn(
          'mb-[0px] mr-0',
          isInfoWindowView ? 'pb-6 xxl:w-[284px]' : 'w-full md:mr-2'
        )}
      >
        <div className='bg-white'>
          {/* Image Skeleton */}
          <Skeleton
            className={cn(
              'h-[180px] w-full',
              !isInfoWindowView && 'md:w-[320px]'
            )}
          />

          {/* Sponsored Badge Skeleton */}
          <div className='mt-2'>
            <Skeleton className='h-5 w-20' />
          </div>

          <div
            className={cn(
              'w-full py-3',
              isInfoWindowView ? 'px-4' : 'md:w-[320px]'
            )}
          >
            {/* Name Skeleton */}
            <Skeleton className='mb-2 h-4 w-1/2' />

            {/* Title Skeleton */}
            <Skeleton
              className={cn(
                'mb-3 h-6 w-full',
                'md:max-w-[320px]',
                isInfoWindowView ? 'line-clamp-2' : 'line-clamp-3'
              )}
            />

            {/* Description Skeleton */}
            <Skeleton
              className={cn(
                'h-16 w-full',
                'md:max-w-[320px]',
                isInfoWindowView ? 'line-clamp-2' : 'line-clamp-7'
              )}
            />
          </div>
        </div>
      </div>

      {/* Button Skeleton */}
      <div className='mt-3 hidden self-end font-bold sm:block'>
        <Skeleton className='h-8 w-28' />
      </div>
    </div>
  );
};

export default RonTipsCardSkeleton;
